export default __webpack_public_path__ + "static/media/Mobile-Slide-1.9515611f.jpg";